import React from 'react';
import {
  Container,
  Typography,
  Paper,
  Box,
  Divider
} from '@mui/material';

const TermsConditions = () => {
  return (
    <Box sx={{ bgcolor: 'grey.100', minHeight: '100vh', py: 8 }}>
      <Container maxWidth="md">
        <Paper elevation={3} sx={{ p: 6 }}>
          <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Terms & Conditions
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Last updated: January 1, 2024
          </Typography>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            By accessing and using the Travel Agency website and services, you agree to be bound by these 
            Terms and Conditions. If you do not agree with any part of these terms, you should not use 
            our services.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            2. Booking and Reservations
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            2.1. All bookings are subject to availability and confirmation from our service providers.<br />
            2.2. Prices are subject to change without prior notice until the booking is confirmed.<br />
            2.3. Special requests are not guaranteed and are subject to availability.<br />
            2.4. It is your responsibility to provide accurate information during the booking process.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            3. Payment Terms
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            3.1. Full payment or deposit (as specified) is required to confirm your booking.<br />
            3.2. Payments can be made through our secure payment gateway or bank transfer.<br />
            3.3. All prices are quoted in Indian Rupees (INR) unless otherwise stated.<br />
            3.4. Additional charges may apply for special services or last-minute bookings.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            4. Cancellation and Refund Policy
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            4.1. Cancellation charges apply as follows:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3, lineHeight: 2 }}>
            <li>30+ days before departure: 25% of package cost</li>
            <li>15-29 days before departure: 50% of package cost</li>
            <li>7-14 days before departure: 75% of package cost</li>
            <li>Less than 7 days: No refund</li>
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            4.2. Refunds will be processed within 7-14 business days.<br />
            4.3. No refunds for unused services or early departure.<br />
            4.4. Force majeure cancellations will be handled on a case-by-case basis.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            5. Travel Documents
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            5.1. It is your responsibility to ensure you have valid passports, visas, and other required 
            travel documents.<br />
            5.2. We are not responsible for delays or cancellations due to incomplete or invalid documentation.<br />
            5.3. Travel insurance is strongly recommended for all travelers.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            6. Liability
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            6.1. Travel Agency acts as an intermediary between you and various service providers 
            (airlines, hotels, tour operators).<br />
            6.2. We are not liable for any loss, damage, injury, or delay caused by third-party service providers.<br />
            6.3. We are not responsible for events beyond our control, including natural disasters, 
            political unrest, or weather conditions.<br />
            6.4. Our liability is limited to the amount paid for the specific service in question.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            7. Website Usage
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            7.1. You agree not to misuse our website or services.<br />
            7.2. All content on this website is our property and protected by copyright laws.<br />
            7.3. You may not reproduce, distribute, or use our content without permission.<br />
            7.4. We reserve the right to modify or discontinue any service without prior notice.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            8. Privacy
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            Your use of our services is also governed by our Privacy Policy, which explains how we collect, 
            use, and protect your personal information.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            9. Modifications to Terms
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            We reserve the right to modify these terms at any time. Continued use of our services after 
            changes constitutes acceptance of the new terms.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            10. Governing Law
          </Typography>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.8 }}>
            These terms are governed by the laws of India. Any disputes shall be subject to the exclusive 
            jurisdiction of the courts in Kolkata, West Bengal.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mt: 3 }}>
            11. Contact Information
          </Typography>
          <Typography variant="body1" sx={{ lineHeight: 2 }}>
            For any questions regarding these terms, please contact:<br />
            Travel Agency Pvt. Ltd.<br />
            Email: {process.env.REACT_APP_EMAILID || 'legal@travelagency.com'}<br />
            Phone: {process.env.REACT_APP_PHONE_NUMBER || '+91 1234567890'}
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsConditions;